angular = require('angular')
pkg = angular.module 'cdms.log', []  
  .factory('Log', require("./log"))  

module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/log/index.coffee